/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Asset, Case, CaseType, Contact } from 'src/app/shared/model/itsm';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { Router } from '@angular/router';
import { OktaAuthService } from 'src/app/app.service';
import { Utilities } from 'src/app/shared/utilities';
import { Pages } from 'src/app/shared/model/shared-items';
import { PrioritiesOrder } from 'src/app/shared/model/activity';
import { PriorityOneErrorContacts } from 'src/app/shared/model/support';
import { UserActivityService } from 'src/app/shared/services/user-activity.service';
import { constants, ACTIONS, PAGES, TYPES } from 'src/app/shared/constants';
import { AssetFilterComponent } from './filters/asset-filter/asset-filter.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-supportlog',
  templateUrl: './supportlog.component.html',
  styleUrls: ['./supportlog.component.scss']
})
export class SupportLogComponent implements OnInit {

  @ViewChild(AssetFilterComponent)
  private assetFilter: AssetFilterComponent;

  caseRef: string;
  case: Case;
  caseloading: boolean;

  userObject: any;

  page: string;
  saved: boolean;
  reqTypeValue: string;

  // dropdown cache
  caseTypeCV: string[];
  caseTypeCvI18n = {
    'Change Request': 'pages.support.dashboard.fieldTitles.changeRequestDesc',
    Incident: 'pages.support.dashboard.fieldTitles.incidentDesc',
    'Service Request': 'pages.support.dashboard.fieldTitles.serviceRequestDesc'
  };
  caseCategoryCV: string[];
  casePriorityCV: string[];
  caseAssetCV: Asset[] = [];
  caseStatusCV: string[];
  contacts: Contact[];
  entitlements: any[];

  vendors: any[];
  services: Service[];
  serviceSearch: string;
  filteredEntitlements: any[];

  filteredAssets: Asset[];
  filteredService: Service[];

  selectedAsset: Asset;

  showAssets: boolean;
  assetError: boolean;
  validCombinations: string[];
  loadingCache: boolean;
  selectedService: {
    id: string;
    serviceName: string;
    serviceCenter: string;
  };
  allowedCaseTypes: string[];
  userEmail: string;
  priorityOneErrorContacts: string[] = [];
  useWorldWatch: boolean;
  assetRef: string;
  worldWatchReferenceRegex: RegExp;
  worldWatchBaseRef = constants.activity.types.signal.baseReference;
  showDateTime = false;

  // handle preferred date constraints
  preferredDateConstraints: { minDelayAllowed: number; minDate: Date };
  minDateAllowed: string;

  public defaultService = {
    id: '',
    serviceName: 'default',
    serviceCenter: undefined
  };

  constructor(
    private alertService: AlertService,
    private itsmService: ItsmService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: OktaAuthService,
    private userActivity: UserActivityService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    // minimum delay to handle a log case. User shouldn't be able to specify an handling time lower than that delay
    this.selectedService = this.defaultService;
    const preferredDateMinDelayAllowed = 25;
    const now = new Date();
    this.preferredDateConstraints = {
      minDelayAllowed: preferredDateMinDelayAllowed,
      minDate: new Date(now.setHours(now.getHours() + preferredDateMinDelayAllowed))
    };

    this.auth.getUserDetails().then(val => {
      this.userEmail = val.email;
    });
    //Hard coded case types to not have to pull all types
    this.route.params.subscribe(params => this.caseRef = params.caseRef);

    this.loadingCache = false;
    this.caseTypeCV = ['Change Request', 'Incident', 'Service Request'];

    // initialize priority one error contacts
    this.priorityOneErrorContacts.push(
      PriorityOneErrorContacts.netherlands,
      PriorityOneErrorContacts.belgium,
      PriorityOneErrorContacts.denmark,
      PriorityOneErrorContacts.norway,
      PriorityOneErrorContacts.sweden,
      PriorityOneErrorContacts.unitedKingdom,
      PriorityOneErrorContacts.germany
    );

    this.loadCache()
      .then(_ => {
        /**
         * If there is an asset ID passed in the query Params,
         * asset, entitlement and service should be updated accordingly
         */

        // init all values from the route params
        this.route.queryParams.subscribe(params => {
          this.case.worldWatchReference = params.signalRef;
          this.useWorldWatch = !! this.case.worldWatchReference;
          this.assetRef = params.asset;
        });

        if (this.assetRef) {
          const asset = this.caseAssetCV.find(a => a.id === this.assetRef);
          if (asset) {
            this.case.assetId = asset.id;
            // update service with asset id
            this.assetSelected(asset);
          }
        }
      });

    /**
     * If there is a case Ref passed in the route,
     * then variables should be populated with case value
     */
    if (this.caseRef) {
      this.caseloading = true;
      this.itsmService.case(this.caseRef)
        .then(res => {
          this.case = res;
          this.caseloading = false;
          if (this.case.worldWatchReference) {
            this.useWorldWatch = true;
          }
        })
        .catch(err => {
          this.alertService.handlerError(err);
          this.caseloading = false;
        });
    } else {
      this.case = new Case();
      this.case.worldWatchReference = this.worldWatchBaseRef;
      this.useWorldWatch = false;
      this.case.dateTime = ''; // FROM ISSGP-62
      this.allowedCaseTypes = [];

      this.auth.getUserDetails().then((val: any) => {
        val.groups.map(g => {
          if (g.includes('Create_')) {
            this.allowedCaseTypes.push(g.substr(g.indexOf('Create_') + 7));
          }
        });

        // filter case type by roles
        this.caseTypeCV = this.caseTypeCV.filter(t =>
          (t === 'Change Request' && this.allowedCaseTypes.includes('Change_Request')) ||
          (t === 'Service Request' && this.allowedCaseTypes.includes('Service_Request')) ||
          (t === 'Incident' && this.allowedCaseTypes.includes('Incident'))
        );

        this.userObject = val;
        if (this.contacts) {
          const cs = this.contacts.filter(c => c.email === this.userObject.email);
          if (cs.length > 0) {
            this.case.contactId = cs[0].id;
          }
        }
      });
    }

    this.page = Pages.create;
    this.worldWatchReferenceRegex = new RegExp(constants.activity.types.signal.regex);
    this.userActivity.logActivity(TYPES.support, PAGES.logCase, ACTIONS.visit);
  }

  setupDateTime() {
    if (!this.showDateTime) {
      this.case.dateTime = '';
    } else {
      this.case.dateTime = this.preferredDateConstraints.minDate.getFullYear().toString()
        + '-'
        + ('0' + (this.preferredDateConstraints.minDate.getMonth() + 1).toString()).slice(-2)
        + '-'
        + ('0' + this.preferredDateConstraints.minDate.getDate().toString()).slice(-2)
        + 'T'
        + ('0' + this.preferredDateConstraints.minDate.getHours().toString()).slice(-2)
        + ':'
        + ('0' + this.preferredDateConstraints.minDate.getMinutes().toString()).slice(-2);
      this.minDateAllowed = this.case.dateTime;
    }
  }

  /**
   *
   * @param dateStr - date string to format
   * @param UTC - true to get output at UTC time | false by default to keep current locale
   * @returns date as string
   */
  formatDate(dateStr: string, UTC = false): string {
    const date = new Date(dateStr);

    const year = UTC ? date.getUTCFullYear() : date.getFullYear();
    const month = UTC ? date.getUTCMonth() + 1 : date.getMonth() + 1;
    const day = UTC ? date.getUTCDate() : date.getDate();
    const hours = UTC ? date.getUTCHours() : date.getHours();
    const minutes = UTC ? date.getUTCMinutes() : date.getMinutes();

    return year.toString()
      + '-'
      + ('0' + month.toString()).slice(-2)
      + '-'
      + ('0' + day.toString()).slice(-2)
      + 'T'
      + ('0' + hours.toString()).slice(-2)
      + ':'
      + ('0' + minutes.toString()).slice(-2);
  }

  private dateTimeCheck() {
    if (this.case.changeType === 'Emergency Change' || !this.showDateTime) { return true; }
    if (!this.case.dateTime) { return false; }
    const currTime = new Date();
    const startTime = new Date(this.case.dateTime);
    return (Math.abs(startTime.getTime() - currTime.getTime()) / 3600000) >= 24;
  }

  private isValidWorldWatchReference(): boolean {
    return (
      this.case.worldWatchReference
      && this.case.worldWatchReference !== undefined
      && this.worldWatchReferenceRegex.test(this.case.worldWatchReference)
    );
  }

  /**
   * Submit case
   */
  public submit() {
    if (this.submitValid()) {
      this.assetError = false;
      this.saved = false;
      this.case.reqType = this.reqTypeValue;
      this.case.worldWatchReference = this.case.worldWatchReference?.split(this.worldWatchBaseRef)[1];

      this.case.description = Utilities.getStringXSSEncoded(this.case.description);
      if (this.case.entitlementId != null) {
        const entitlement = this.entitlements.find(ent => ent.id === this.case.entitlementId);
        this.case.serviceType = entitlement.serviceType;
        this.case.serviceName = entitlement.serviceName;
      }

      if (this.case.type === CaseType.changeRequest) {
        this.case.dateTime = this.formatDate(this.case.dateTime, true);
      }

      this.page = Pages.submit;

      if (this.case.id) {
        this.case.updatedBy = this.userEmail;
        this.itsmService.caseUpdate(this.case)
          .then(res => {
            this.case = res;
            this.alertService.addSuccess(this.translateService.instant('pages.support.log.saved'));
            this.saved = true;
          })
          .catch(err => {
            this.alertService.handlerError(err);
          });
      } else {
        this.case.openedBy = this.userEmail;
        this.itsmService.caseCreate(this.case)
          .then(res => {
            this.case = res;
            this.saved = true;
            this.alertService.addSuccess(this.translateService.instant('pages.support.log.saved'));
            this.userActivity.logActivity(TYPES.support, PAGES.logCase, ACTIONS.logCase);
            this.goToCase(this.case.id);
          })
          .catch(err => {
            this.alertService.handlerError(err);
          });
      }
    }
  }

  /**
   * Cache the CV values for the dropdowns
   */
  private loadCache() {
    this.loadingCache = true;
    return Promise.all([
      Promise.resolve(), // was this.itsmService.getCachedCV('Case','Type'),
      this.itsmService.getCachedCV('Case', 'Priority'),
      this.itsmService.getCachedAssets(),
      this.itsmService.getCachedCV('Case', 'Status'),
      this.itsmService.getCachedContacts(),
      this.itsmService.getCachedServices()
    ])
      .then(res => {
        this.casePriorityCV = res[1].filter(n =>
          n === PrioritiesOrder.critical ||
          n === PrioritiesOrder.high ||
          n === PrioritiesOrder.medium ||
          n === PrioritiesOrder.low
        );
        this.caseAssetCV = res[2];
        this.caseStatusCV = res[3];
        this.contacts = res[4];
        this.entitlements = res[5];

        this.getTicketableEntitlements();
        this.getTicketableAssets();
        this.extractServiceNames();

        this.filteredAssets = this.caseAssetCV;

        if (this.caseAssetCV && this.caseAssetCV.length > 0) {
          this.reqTypeValue = 'supOp';
        } else if (this.entitlements && this.entitlements.length > 0) {
          this.reqTypeValue = 'detResp';
        }
      })
      .then(() => {
        this.loadingCache = true;
      })
      .then(() => {
        this.loadingCache = false;
      })
      .catch(err => {
        this.alertService.handlerError(err);
      });
  }

  /**
   * Redirect to case created
   */
  goToCase(caseId) {
    this.router.navigate(['/support/view', caseId]);
  }

  /**
   * extract services names from entitlements
   */
  extractServiceNames() {
    this.entitlements.sort((e1, e2) => {
      const rankValue1 = parseInt(e1.rankValue, 10) || 0;
      const rankValue2 = parseInt(e2.rankValue, 10) || 0;
      return rankValue2 - rankValue1;
    });

    let services = [];
    this.entitlements.forEach(ent =>
      services.push({ id: ent.id, serviceName: ent.serviceName || ent.name, serviceCenter: ent.serviceCenter })
    );
    services = services.concat(this.entitlements);
    services = services.filter(sn => sn.serviceName !== '');
    services = [...new Map(services.map(s => [s.serviceName, s])).values()]; //remove duplicated service name
    this.services = services;
    this.filteredService = services;
  }

  /**
   * filter entilements and return only entitlement ticketable & active
   */
  getTicketableEntitlements() {
    this.entitlements = this.entitlements.filter(e => {
      // some UK contracts can't have tickets logged against them, and are flagged with "nonTicketable"
      const ticketable = (e.nonTicketable && e.nonTicketable === 'true') ? false : true;
      const active = (e.active === 'true');
      return active && ticketable;
    });
  }

  /**
   * filter assets and return only those active and with one contract
   */
  getTicketableAssets() {
    let assets = [];
    // get all contract ids a ticket can be logged against
    const contracts = this.entitlements;
    const contractIds = contracts.map(c => c.id);

    assets = this.caseAssetCV.filter(a => {
      const active = (a.active === 'true');
      let hasContract = false;

      // we can skip the loop if the asset is already eliminated for being inactive
      if (active) {
        if (a.entitlements && a.entitlements.length > 0) {
          // check asset has at least one usable contract
          a.entitlements.forEach(e => {
            if (contractIds.indexOf(e.id) !== -1) {
              hasContract = true;
            }
          });
        }
      }

      return (active && hasContract);
    });

    this.caseAssetCV = assets;
  }

  /**
   * when a asset is selected,
   * update the entitlement and service with the first available values.
   */
  onAssetUpdate(item: Asset) {
    if (item == null) {
      this.assetRemoved();
    } else {
      this.assetSelected(item);
    };
  }

  /**
   * remove selected asset
   */
  private assetRemoved() {
    // asset has been removed
    this.case.assetId = undefined;
    this.case.entitlementId = undefined;
    if (this.selectedService) {
      this.onSelectService();
    } else {
      // maybe asset list has been filtered, reset it with all values
      this.filteredAssets = this.caseAssetCV;
    }
  }

  /**
   * select asset
   */
  private assetSelected(item) {
    // asset has been selected
    this.case.assetId = (item.id) ? item.id : false;

    // filter all service that contains asset
    const filtered = this.getAssetServices(item);

    if (this.selectedService == null || this.selectedService === this.defaultService) {
      if (filtered.length === 1) {
        // if only one service available, select id
        this.selectedService = filtered[0];
        this.filteredAssets = this.getServiceAssets();
        this.case.contractId = this.selectedService.id;
        this.case.serviceCenter = this.selectedService.serviceCenter;
      } else {
        // if no selected service, filter services that are include in the asset
        this.filteredService = filtered;
      }
    }
  }

  /**
   * when user select a new service from the dropdown
   */
  public onSelectService() {

    this.assetFilter.resetVendorSearch();
    const fileredAssets = this.getServiceAssets();
    const filterdAssetIds = fileredAssets.map(a => a.id);

    // selected service is the default one
    const isdefaultService = this.selectedService === this.defaultService;
    // asset has already been selected without service
    const assetSeletedWithoutService = this.case.assetId && !this.selectedService;
    // case has already been selected and changed service include existing asset
    const assetAndServiceSelected = this.case.assetId && this.selectedService && filterdAssetIds.includes(this.case.assetId);
    // service selected some asset are available
    const serviceWithMultipleAssets = fileredAssets && fileredAssets.length > 0;

    if (isdefaultService) {
      this.case.contractId = undefined;
      this.case.assetId = undefined;
      this.filteredAssets = this.caseAssetCV;
    } else if (assetSeletedWithoutService || assetAndServiceSelected) {
      this.case.contractId = this.selectedService.id;
      this.case.serviceCenter = this.selectedService.serviceCenter;
      this.filteredAssets = fileredAssets;
    } else if (serviceWithMultipleAssets) {
      this.case.contractId = this.selectedService.id;
      this.filteredAssets = fileredAssets;
      this.case.serviceCenter = this.selectedService.serviceCenter ? this.selectedService.serviceCenter : undefined;
      // if only one asset exists, select it directly
      this.case.assetId = fileredAssets.length === 1 ? fileredAssets[0].id : undefined;
    } else {
      // service selected withtout but no assets available
      this.case.assetId = undefined;
      this.filteredAssets = [];
      this.case.contractId = this.selectedService.id;
    }

    this.filteredService = this.services;
  }

  /**
   * get all assets for the current service
   */
  private getServiceAssets(): Asset[] {

    // get all entitlement ids for the selected service
    const entitlementIds = this.entitlements
      .filter(e => (e.serviceName === this.selectedService.serviceName) || e.name === this.selectedService.serviceName)
      .map(e => e.id);

    return this.caseAssetCV.filter((asset: any) => {
      if (asset.entitlements && asset.entitlements.length > 0) {
        const filterArray = asset.entitlements.filter((ass: any) => entitlementIds.includes(ass.id));
        return filterArray.length > 0;
      }
      return false;
    });
  }

  /**
   * get all services for the current asset
   */
  private getAssetServices(asset) {

    // récupère les entitlement id
    const selectedAssetEntitlementIds = asset.entitlements.map(e => e.id);

    // récupérer tous les name ou servicename de l'entitlement
    const name = [];
    this.entitlements.filter(e => selectedAssetEntitlementIds.includes(e.id))
      .forEach(e => {
        if (!name.includes(e.name)) {
          name.push(e.name);
        }
        if (!name.includes(e.serviceName)) {
          name.push(e.serviceName);
        }
      });

    // chercher dans les services
    return this.services.filter(s => name.includes(s.serviceName));

  }

  public removeSelectedService() {
    this.selectedService = this.defaultService;
    this.case.contractId = undefined;
    this.case.assetId = undefined;
    this.filteredAssets = this.caseAssetCV;
  }

  public isServiceNameValid() {
    return (this.selectedService && this.selectedService.serviceName !== 'default');
  }


  /**
   * validate user submission
   */
  public submitValid(): boolean {

    const isNotDefault = this.selectedService && this.selectedService.serviceName !== 'default';
    const noAssetAvailable = isNotDefault && this.filteredAssets.length === 0;
    const assetSelected = isNotDefault && this.filteredAssets.length > 0 && this.case.assetId;

    if (

      (
        this.case.type &&
        this.case.subject &&
        this.case.description &&
        this.case.contactId &&
        this.isServiceNameValid() &&
        this.case.contractId &&
        (noAssetAvailable || assetSelected)
      )
      &&
      (
        (this.case.type === 'Change Request' && this.case.changeType && this.dateTimeCheck())
        ||
        (this.case.type === 'Incident' && this.case.priority && this.case.priority !== '1 - Business Critical')
        ||
        (this.case.type === 'Service Request')
      )
      && (
        !this.useWorldWatch || (this.useWorldWatch && this.isValidWorldWatchReference())
      )
    ) {

      return true;
    } else {
      return false;
    }
  }


}

export class Service {
  id: string;
  serviceName: string;
  serviceCenter: string;

  constructor(id: string, serviceName: string, serviceCenter: string) {
    this.id = id;
    this.serviceName = serviceName;
    this.serviceCenter = serviceCenter;
  }
}
